import Game from "../../Game";
import { FBTrackingEvent } from "./FBTrackingEvent";

export async function gameTracking(
    event: FBTrackingEvent,
    value: number = 1,
    params: { [key: string]: string } = null
) {
    try {
        await Game.sdk.gameTracking(event, value, params);
    } catch (e) {
        console.error(e);
    }
}
